import React from 'react';
import './Mentorship.css';

function MentorStat({value, label}) {
  return (
    <div className="mentor-stat">
      <div className="mentor-stat-value">{value}</div>
      <div className="mentor-stat-label">{label}</div>
    </div>
  );
}

const achievements = [
  {
    main: (
      <>
        Mentees secured internships at <strong>J-PAL South Asia</strong>, <strong>Accenture AI</strong>, <strong>CITI Group</strong> and more!
      </>
    ),
  },
  {
    main: (
      <>
        <strong>64%</strong> of YWEP 1 mentees achieved their short term goals
      </>
    ),
  },
  {
    main: (
      <>
        Mentees received admission offers from <strong>Columbia University</strong>, <strong>London School of Economics</strong> and more!
      </>
    ),
  },
];

function Mentorship() {
  return (
    <div className="mentorship__container">
      <div className="mentorship__hero">
        <div className="mentorship__hero-main">
          <div>
            <h1>YWEP</h1>
            <h2>Young Women in Economics Program</h2>
            <p className="mentorship__subtitle">A mentorship program by Women in Econ & Policy</p>
          </div>
        </div>
      </div>

      {/* Stats Box */}
      <div className="mentorship__stats-box">
        <div className="mentorship__stats-section">
          <MentorStat value="100" label="Mentees over 2 years" />
          <MentorStat value="6 months" label="of 1:1 mentorship" />
          <MentorStat value="12+" label="Info & Skill Sessions / year" />
        </div>
      </div>


      {/* Scale-up Program Section */}
      <div className="mentorship__scaleup-section">
        <div className="mentorship__scaleup-wrapper">
          <h2 className="mentorship__scaleup-title">Scale-up Program</h2>
          <div className="mentorship__scaleup-content">
            <p className="mentorship__scaleup-intro">
              Women in Econ/Policy is scaling up an in-person, comprehensive version of its Young Women in Economics Program (YWEP) and is currently partnering with colleges across India to offer a free, intensive 3-year program that supports women students aspiring to build careers in economics and policy.
            </p>
            <p>
              Now in its <strong>fifth iteration beginning September/October 2025</strong>, we are working with <strong>nine colleges across India</strong>, providing:
            </p>
            <ul className="mentorship__scaleup-features">
              <li>Information sessions on careers in academia, the corporate sector, government and beyond</li>
              <li>Workshops on practical skills such as CV building, cover letter writing and data analysis software</li>
              <li>Support to create campus-based peer networks for sharing opportunities</li>
              <li>Access to Women in Econ/Policy's wider resources and community</li>
              <li>In the final year of study, the chance to be selected for 1:1 mentorship with a mid-career woman professional in the student's field of interest</li>
            </ul>
            <p className="mentorship__scaleup-support">
              This initiative is supported by funding from the <strong>International Economics Association's Women in Economics Initiative (IEA-WE)</strong>, led by Professor Ashwini Deshpande at Ashoka University, in collaboration with a global network of scholars.
            </p>
            <div className="mentorship__scaleup-colleges">
              <p>
                We have conducted approximately <strong>4 sessions per college</strong> in various colleges, including:
              </p>
              <div className="mentorship__scaleup-college-list">
              <span className="mentorship__scaleup-college-tag">Aurobindo College</span>
                <span className="mentorship__scaleup-college-tag">Sri Guru Gobind Singh College Of Commerce, Delhi University</span>
                <span className="mentorship__scaleup-college-tag">Madras School of Economics</span>
                <span className="mentorship__scaleup-college-tag">Islamic University of Science and Technology</span>
                <span className="mentorship__scaleup-college-tag">SGGGSC, DU</span>
                <span className="mentorship__scaleup-college-tag">APU</span>
                <span className="mentorship__scaleup-college-tag">MSE</span>
                <span className="mentorship__scaleup-college-tag">IUST</span>
                <span className="mentorship__scaleup-college-tag">TERI</span>
                <span className="mentorship__scaleup-college-tag">BASE</span>
                <span className="mentorship__scaleup-college-tag">Aurobindo</span>
                <span className="mentorship__scaleup-college-tag">Symbiosis</span>
                <span className="mentorship__scaleup-college-tag">AUD</span>
              </div>
            </div>
            <div className="mentorship__scaleup-resources">
              <h3 className="mentorship__scaleup-resources-title">Resources for the sessions conducted</h3>
              <div className="mentorship__scaleup-links">
                <a href="https://www.dropbox.com/scl/fo/osysh34zv47mzcpyc1lnn/AA3OVD962_yQqboNFZhtUfQ?rlkey=vniiqbrzycrjds0jdgo9kgxvy&dl=0" target="_blank" rel="noopener noreferrer" className="mentorship__scaleup-link-button">
                  <span className="mentorship__scaleup-link-icon"></span>
                  <span>Presentations</span>
                </a>
                <a href="https://www.dropbox.com/scl/fo/ios2s9iwte4keuchuwzu5/AG17eMzSXmDCi_Q4hIrYnCU?rlkey=8c3mupqzwif17kj7skwtn0f03&dl=0" target="_blank" rel="noopener noreferrer" className="mentorship__scaleup-link-button">
                  <span className="mentorship__scaleup-link-icon"></span>
                  <span>Write-ups</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial Section */}
      <div className="mentorship__testimonial-section">
        <div className="mentorship__testimonial-block">
          <div className="mentorship__testimonial-quote">
            ‘I think YWEP was the perfect platform for me right out of my undergraduate degree. Being from a state university, I think it becomes very easy for people to get overlooked and programs like these are really quintessential for anyone who wants to grow to be able to create an impact. Listening to leaders and visionaries from different fields was very inspiring and being able to interact with them was an amazing opportunity. With how women are neglected happens through a cross-cutting of various groups in our society, the upskilling, mentorship and networking opportunities will be very beneficial. Being a part of this all-women group has been very inspiring.’
          </div>
          <div className="mentorship__testimonial-author">
            - Saloni Drolia (Mentee - YWEP 1)
          </div>
        </div>
      </div>

      {/* Partners Section */}
      <div className="mentorship__partners-section">
        <h2 className="mentorship__partners-title">Our Partners</h2>
        <p className='mentorship__partners-desc'>We have partnered with leading organizations, universities, non-profits and social enterprises in the economics, policy and development space.</p>
        <div className="mentorship__partners-logos">
          <img src= '/logo.png' alt="WWF Logo"/>
          <img src='/mentorshiplogo1.png' alt="World Economic Forum Logo"/>
          <img src='/mentorshiplogo2.png' alt="Teach For Canada Logo"/>
          <img src='/mentorshiplogo3.png' alt="Oxfam Canada Logo"/>
          <img src='/mentorshiplogo4.png' alt="Fair Food Network Logo"/>
          <img src='/mentorshiplogo5.png' alt="United Nations Logo"/>
          <img src='/mentorship6.png' alt="Gairdner Logo"/>
        </div>
      </div>
    </div>
  )
}

export default Mentorship;

